import React from 'react';
import { Field, FieldConfig, useField } from 'formik';
import { Input, InputProps } from '@sls-react/design-system';

type Props = Omit<InputProps, 'name'> & Omit<FieldConfig, 'value'>;

const FormikInput = React.forwardRef<HTMLInputElement, Props>(
  ({ children, name, ...props }, ref) => {
    const [field, meta, helpers] = useField(name);

    return (
      <Field
        as={Input}
        {...props}
        {...field}
        error={meta.error}
        name={name}
        innerRef={ref}
      >
        {children}
      </Field>
    );
  },
);

export default FormikInput;
